import { fmtFecha } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { CoberturaZonasGrid, CeldaZona, inicialesZona } from "@/components/ZonasCobertura";
import DuplicarZonaMenu from "@/components/DuplicarZonaMenu";

export default function ZonasPlanDia({
  plan,
  onEditTramo,
  onAddTramo,
  onDuplicateTramo,
  onDuplicateDia,
  onAssignFromCobertura,
  onEditTramoFromCobertura,
}) {
  if (!plan) return null;

  const dia = plan.dias?.[0] || { fecha: plan.fecha, nombre: "" };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-zinc-200 bg-white px-4 py-3 shadow-sm">
        <div className="flex flex-wrap items-center gap-3 text-xs">
          <span className="text-sm font-semibold text-zinc-800">{fmtFecha(plan.fecha)}</span>
          {plan.borradores_pendientes > 0 && (
            <Badge variant="outline" className="border-amber-300 bg-amber-50 text-amber-800">
              {plan.borradores_pendientes} cambio{plan.borradores_pendientes !== 1 ? "s" : ""} sin publicar
            </Badge>
          )}
        </div>
      </div>

      {plan.zonas?.length > 0 && (
        <div className="flex flex-wrap gap-3 rounded-xl border border-fuchsia-100 bg-gradient-to-r from-fuchsia-50/80 to-violet-50/80 px-4 py-2 text-xs">
          {plan.zonas.map((z) => (
            <span key={z.id} className="flex items-center gap-1.5 text-zinc-600">
              <span className="h-3 w-3 rounded" style={{ backgroundColor: z.color }} />
              {z.nombre}
            </span>
          ))}
        </div>
      )}

      <CoberturaZonasGrid
        dias={plan.dias || [dia]}
        horas={plan.horas || []}
        coberturaZonas={plan.cobertura_zonas || []}
        resumenLabel="asign. día"
        onCellClick={(zona, fecha, info) => onAssignFromCobertura?.(zona, fecha, plan.empleados, info)}
        onTramoClick={(tramo) => onEditTramoFromCobertura?.(tramo, plan.empleados, plan.fecha)}
      />

      <div className="overflow-x-auto rounded-2xl border border-zinc-200 bg-white shadow-sm">
        <table className="w-full min-w-[600px] border-collapse text-xs" data-testid="zonas-grid">
          <thead>
            <tr className="border-b border-zinc-200 bg-zinc-50">
              <th className="sticky left-0 z-10 min-w-44 bg-zinc-50 px-3 py-2 text-left font-semibold text-zinc-600">
                Empleado
              </th>
              <th className="min-w-[10rem] px-2 py-2 text-center font-medium text-zinc-500">
                <span className="block text-[10px] text-violet-600">{dia.nombre}</span>
                <span className="text-[9px] text-zinc-400">{fmtFecha(plan.fecha).slice(0, 5)}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {plan.empleados.map((emp) => (
              <tr key={emp.id} className="border-b border-zinc-100 hover:bg-zinc-50/50">
                <td className="sticky left-0 z-10 border-r border-zinc-100 bg-white px-3 py-2">
                  <div className="flex items-center gap-2">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-violet-100 text-[10px] font-bold text-violet-700">
                      {inicialesZona(emp.nombre)}
                    </span>
                    <div>
                      <p className="font-medium text-zinc-800">{emp.nombre}</p>
                      {emp.departamento && <p className="text-[10px] text-zinc-400">{emp.departamento}</p>}
                      {emp.horario?.franjas?.length > 0 && !emp.horario?.ausencia && (
                        <p className="mt-0.5 text-[9px] text-sky-700">
                          {emp.horario.franjas.map((f) => `${f.inicio}–${f.fin}`).join(" · ")}
                        </p>
                      )}
                    </div>
                  </div>
                </td>
                <td className="align-top px-1 py-1.5">
                  <CeldaZona
                    emp={emp}
                    fecha={plan.fecha}
                    onTramoClick={(e, t) => onEditTramo?.(e, t)}
                    onAdd={(e) => onAddTramo?.(e)}
                  />
                  {emp.horario?.activo && !emp.horario?.ausencia && emp.tramos?.length > 0 && (onDuplicateDia || onDuplicateTramo) && (
                    <DuplicarZonaMenu
                      tramos={emp.tramos}
                      onDuplicarDia={onDuplicateDia ? () => onDuplicateDia(emp) : undefined}
                      onDuplicarTramo={onDuplicateTramo ? (t) => onDuplicateTramo(emp, [t.id]) : undefined}
                    />
                  )}
                </td>
              </tr>
            ))}
            {!plan.empleados.length && (
              <tr>
                <td colSpan={2} className="px-4 py-8 text-center text-sm text-zinc-400">
                  No hay empleados activos en tu ámbito.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-zinc-500">
        Clic en la cobertura por zona, en una celda vacía o en un tramo para asignar o editar. Los cambios son borrador hasta publicar.
      </p>
    </div>
  );
}
